import React from 'react'

import { Box } from './core'

export const BoundedBox = React.forwardRef(
  ({ maxWidth = 'xlarge', children, ...props }, ref) => (
    <Box ref={ref} {...props}>
      <Box maxWidth={maxWidth} mx="auto" height="100%">
        {children}
      </Box>
    </Box>
  ),
)
